/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyExternalSystem,
    ReadOnlyExternalSystemFromJSON,
    ReadOnlyExternalSystemFromJSONTyped,
    ReadOnlyExternalSystemToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20014
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20014
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20014
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyExternalSystem>}
     * @memberof InlineResponse20014
     */
    results: Array<ReadOnlyExternalSystem>;
}

export function InlineResponse20014FromJSON(json: any): InlineResponse20014 {
    return InlineResponse20014FromJSONTyped(json, false);
}

export function InlineResponse20014FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20014 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyExternalSystemFromJSON)),
    };
}

export function InlineResponse20014ToJSON(value?: InlineResponse20014 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyExternalSystemToJSON)),
    };
}


